import axios from "axios";
import { AccountType } from "shared/types/accounts";

export async function connectTikTokAccount({
  login,
  profilePictureUrl,
}: {
  login: string;
  profilePictureUrl: string;
}): Promise<AccountType> {
  const {
    data: { data },
  } = await axios.post("/accounts/tt", {
    login,
    profilePictureUrl,
    platformType: "TT",
  });

  return data;
}

export function getTikTokRedirect(
  reconnect: boolean,
  username?: string,
  accountId?: string,
  includeDmScopes = false
): string {
  let url = "/tiktok/request_token";

  if (reconnect) {
    url =
      url +
      "?username=" +
      username +
      "&reconnect=true" +
      `${accountId ? `&accountId=${accountId}` : ""}` +
      `${includeDmScopes ? "&includeDmScopes=true" : ""}`;
  }
  return url;
}
